'use strict';

const HOOK = '[data-application-close]';

window.addEventListener('DOMContentLoaded', () => {
    let button = document.querySelector(HOOK);
    if (button) {
        button.addEventListener('click', () => {
            if (window.opener) {
                window.close();
            } else {
                let button = document.querySelector(HOOK);
                window.top.location.href = button.href;
            }
        });
    }
});
